jQuery(function($) {
	$(document).ready(function() {    

		// members form
	    $( "li.split-label" ).append( "<div class='clear'></div>" );	
		$( "#gf_page_steps_2" ).append( "<div class='steps-line'></div>" );	
		$(".gf_step").html(function(i, h) {
	    	return h.replace(/&nbsp;/gi, "");
		});
		$('.gform_next_button').val('Next >');
		$('.gform_previous_button').val('< Back');
		if(('.gchoice_2_8_0 .membership-choice').length != 1){
			$( ".gchoice_2_8_0" ).append( "<div class='membership-choice'>NHS health board, university or company of 250 employees or more.<br /><span class='membership-price'>&pound;1,200 + VAT per annum</span></div><div class='clear'></div>" );
		}
		if(('.gchoice_2_8_1 .membership-choice').length != 1){
			$( ".gchoice_2_8_1" ).append( "<div class='membership-choice'>Organisations with fewer than 250 employees or academic department.<br /><span class='membership-price'>&pound;850 + VAT per annum</span></div><div class='clear'></div>" );
		}
		if(('.gchoice_2_8_2 .membership-choice').length != 1){
			$( ".gchoice_2_8_2" ).append( "<div class='membership-choice'>Small organisation with 10 employees or less.<br /><span class='membership-price'>&pound;495 + VAT per annum</span></div><div class='clear'></div>" );
		}
		if(('.gchoice_2_8_3 .membership-choice').length != 1){
			$( ".gchoice_2_8_3" ).append( "<div class='membership-choice'>Sole trader, start-up or organisation with one or two employees.<br /><span class='membership-price'>&pound;295 + VAT per annum</span></div><div class='clear'></div>" );
		}
			
		$('.gfield_radio input').click(function() {
			// Out with the old...
			$('input.checked_radio').closest('li').removeClass("highlighted");
			$('.gfield_radio input').removeClass("checked_radio");
			
			// ...and in with the new
			$(this).addClass("checked_radio")
			.closest('li').addClass('highlighted'); 	
		});    

		//active class to parent of checked radio
		var $radioButtons = $('input[type="radio"]');
		$radioButtons.click(function() {
		    $radioButtons.each(function() {
		    	//remove class on click
		        $(this).parent().removeClass('checked', this.checked);
		    });
		});
		//add class if page reached from previous page
		$('input[type="radio"]:checked').parent().addClass('checked');

		if($('#news-grid').length > 0){
			$('#news-grid').masonry({
			  itemSelector: '#news-grid .news-item',
			  columnWidth: '.grid-sizer',
			  gutter: '.gutter-sizer',
			  percentPosition: true
			});
		}

		$('#search-toggle').click(function(){
			if($('#search-bar').hasClass('open')){
				$('#search-bar').removeClass('open');
			} else {
				$('#search-bar').addClass('open');	
			}
			
			//$('#search-bar.open').removeClass('open');
		});	

		//open mobile search
		$('#mobile-search-open').click(function(){
			$('#search-bar').addClass('open');
		});  
		//close mobile search
		$('#search-close').click(function(){
			$('#search-bar').removeClass('open');
		});

		$(function() {
		  //$('select').selectric();
		});
	});
});